<div class="row">
    <div class="col-md-12 col-12 main-content">
      <app-search-book-form [stations]="stationList" title="{{ 'AUTOPARTAGE.SEARCH.TITLE' | translate }}" [mapStationSelected]="mapStationSelected"
        (stationChanged)="stationChangedHandler($event)"></app-search-book-form>
    </div>
     <!-- mont des avalois -->
    <div *ngIf="isMontDesAvaloirs === true" class="col-12 margin-block">
      <app-car-bloc-autopartage></app-car-bloc-autopartage>
    </div>
    <!-- avantages -->
    <div class="col-12 margin-block">
      <app-info-bloc-autopartage></app-info-bloc-autopartage>
    </div>
    <!-- comment ca marche -->
    <div class="col-12 margin-block">
      <app-ccm-autopartage></app-ccm-autopartage>
    </div>
</div>
